import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { KTSVG } from "../../../_metronic/helpers";
import { employeeTypeInitialsForAdd, employeeTypeInitialsForUpdate } from "./interfaces/EmployeeTypeClass";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { addAccountEmployeeTypeAsync, updateAccountEmployeeTypeAsync, resetSelectedRecordObjectInState } from "./EmployeeTypeSlice";
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik } from 'formik';
import {getValueFromResource } from "../../../common/timeLiveFunction";
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';


export const EmployeeTypeForm = (props: any) => {
    const [disabledCount, setDisabledCount] = useState(0)
    const { modelRef, t, oncloseModal } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(employeeTypeInitialsForAdd);
    const { selectedRecord, employeeTypeList, isLoading } = useAppSelector((state) => state.employeeType);
    const { manageTerminologyList } = useAppSelector((state) => state.globalState);
    const dispatch = useAppDispatch();

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(employeeTypeInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsVendor = stateItem.IsVendor === 'Yes' ? true : false;
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(employeeTypeInitialsForAdd);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
        calculatedDisabledValue();

    }, [selectedRecord])

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateAccountEmployeeTypeAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Employee type Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        else {
            dispatch(addAccountEmployeeTypeAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Employee type Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        oncloseModal();
    }
    const calculatedDisabledValue = () => {
        if (employeeTypeList.length > 0) {
            let index = 0;
            employeeTypeList.forEach((value) => {
                if (value.IsDisabled.toString() == 'Yes') {
                    index = index + 1
                }
            });
            setDisabledCount(employeeTypeList.length - index);
        }
    }
    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    AccountEmployeeType: yup
                        .string()
                        .label('AccountEmployeeType')
                        .trim()
                        .required(t('Employee type is required'))
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className="modal drawer-overlay" style={{ display: 'block' }}
                                        >
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                              <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ?
                                                        //  t('Update')
                                                        getValueFromResource('Update ',dispatch, t)
                                                           :
                                                            // t('Add')}
                                                            getValueFromResource('Add ',dispatch, t)}

                                                            {getValueFromResource('Employee Type', dispatch, t)}
                                                        </h5>

                                                        <div
                                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                            onClick={oncloseModal}
                                                        >
                                                            <KTSVG
                                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                                className="svg-icon svg-icon-1x"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="modal-body">
                                                        <form className='form'>
                                                            <div className="mb-0">
                                                                <label className="fs-7 fs-7 fw-normal">
                                                                    {/* {t('Employee Type')} */}
                                                                    {getValueFromResource('Employee Type',dispatch, t)}

                                                                    </label>
                                                                <input type="text" className="form-control fs-7 fw-normal mt-2" id='AccountEmployeeType' value={values.AccountEmployeeType} name='AccountEmployeeType'
                                                                    onChange={handleChange('AccountEmployeeType')}
                                                                    style={{ color: '#172b4d' }}
                                                                    ref={defaultFocusRef}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('AccountEmployeeType', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5, paddingBottom: 5 }}>
                                                                {touched.AccountEmployeeType && errors.AccountEmployeeType &&
                                                                    <p className='errorMsg'>{errors.AccountEmployeeType as string}</p>
                                                                }
                                                            </div>
                                                            <div className="mb-3 mt-2" >
                                                                <label className="fs-7 fw-normal d-flex align-items-center gap-1">
                                                                    {/* {t('Is Vendor')} */}
                                                                    {getValueFromResource('Is Vendor', dispatch, t)}
                                                                    <div
                                                                        style={{ marginBottom: "2px" }}
                                                                        data-tooltip-id="employee-type-vendor-tooltip"
                                                                        data-tooltip-content={getValueFromResource('Enable this option if this employee type represents vendors or third-party personnel instead of internal employees. This may affect available features and workflows.', dispatch, t)}
                                                                    >
                                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                                                                    </div>
                                                                </label>
                                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                    <input className="form-check-input h-20px w-30px mt-2"
                                                                        type="checkbox"
                                                                        checked={values.IsVendor}
                                                                        id="IsVendor"
                                                                        name="IsVendor"
                                                                        onChange={handleChange('IsVendor')}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {Object.keys(selectedRecord).length > 0 ? (
                                                                disabledCount !== 1 ? <div className="mb-3" >
                                                                    <label className="fs-7 fw-normal mt-2">
                                                                        {/* {t('Disabled')} */}
                                                                        {getValueFromResource('Disabled',dispatch, t)}

                                                                        </label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                            onChange={handleChange('IsDisabled')}
                                                                        />
                                                                    </div>
                                                                </div> : employeeTypeList.find(x => x.AccountEmployeeTypeId === values.AccountEmployeeTypeId)?.IsDisabled.toString() === "Yes" && (<div className="mb-3" >
                                                                    <label className="fs-7 fw-normal mt-2">
                                                                        {/* {t('Disabled')} */}
                                                                        {getValueFromResource('Disabled',dispatch, t)}

                                                                        </label>
                                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                        <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                            onChange={handleChange('IsDisabled')}
                                                                        />
                                                                    </div>
                                                                </div>)
                                                            ) : null}
                                                        </form>
                                                    </div>
                                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                            onClick={oncloseModal}
                                                        >
                                                            {/* {t('Cancel')} */}
                                                            {getValueFromResource('Cancel',dispatch, t)}
                                                        </button>
                                                        <button type="button" className="btn btn-primary btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                            {/* {t('Save')} */}
                                                            {getValueFromResource('Save',dispatch, t)}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </form>
                    </Fragment>
                )}
            </Formik>
            <ReactTooltip
                id="employee-type-vendor-tooltip"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )

}

export default EmployeeTypeForm